import React from "react";
import {
  THERMAL_SHOP_DEFAULTS,
} from "./ThermalCustomerInvoice";

const parseNamePhone = (value) => {
  const s = String(value ?? "").trim();
  const match = s.match(/^(.+?)\s*[-–]\s*(.+)$/);
  if (match) return { name: match[1].trim(), phone: match[2].trim() };
  return { name: s, phone: "" };
};

export const getShopHeaderProps = (data = {}) => {
  const {
    shopTitleLine,
    shopName = THERMAL_SHOP_DEFAULTS.shopName,
    managerLabel = THERMAL_SHOP_DEFAULTS.managerLabel,
    managerPhone: managerPhoneProp,
    managerContact = THERMAL_SHOP_DEFAULTS.managerContact,
    ownerLabel = THERMAL_SHOP_DEFAULTS.ownerLabel,
    ownerPhone: ownerPhoneProp,
    ownerContact = THERMAL_SHOP_DEFAULTS.ownerContact,
    logoSrc = THERMAL_SHOP_DEFAULTS.logoSrc,
  } = data;

  const titleLine =
    shopTitleLine ||
    THERMAL_SHOP_DEFAULTS.shopTitleLine ||
    shopName;

  const managerParsed = parseNamePhone(managerContact);
  const ownerParsed = parseNamePhone(ownerContact);

  return {
    logoSrc,
    titleLine,
    leftStaffLabel: managerLabel || "Manager",
    leftStaffPhone:
      managerPhoneProp ||
      managerParsed.phone ||
      THERMAL_SHOP_DEFAULTS.managerPhone,
    rightStaffLabel:
      ownerLabel || ownerParsed.name.split(" ")[0] || "Wajahat",
    rightStaffPhone:
      ownerPhoneProp || ownerParsed.phone || THERMAL_SHOP_DEFAULTS.ownerPhone,
  };
};

const DashedRule = () => <div className="tr-dash" />;

/**
 * @param {{ formattedDate: string, headerRight?: React.ReactNode, shop: ReturnType<typeof getShopHeaderProps>, showRuleAfter?: boolean }} props
 */
export const ThermalShopHeader = ({
  formattedDate,
  headerRight,
  shop,
  showRuleAfter = true,
}) => (
  <>
    <div className="tr-header-meta">
      <div className="tr-date-top">{formattedDate}</div>
      {headerRight}
    </div>
    <div className="tr-logo-wrap">
      <img src={shop.logoSrc} alt="" className="tr-logo" />
    </div>
    <div className="tr-shop-title">{shop.titleLine}</div>
    <div className="tr-staff-row">
      <div className="tr-staff-col">
        <div className="tr-staff-label">{shop.leftStaffLabel}</div>
        <div className="tr-staff-phone">{shop.leftStaffPhone}</div>
      </div>
      <div className="tr-staff-col tr-staff-col-right">
        <div className="tr-staff-label">{shop.rightStaffLabel}</div>
        <div className="tr-staff-phone">{shop.rightStaffPhone}</div>
      </div>
    </div>
    {showRuleAfter && <DashedRule />}
  </>
);

export { DashedRule };
